// The site's author identity — one source of truth for every byline, author
// card, and disclosure the React pages render. The crawler-visible twin of
// this lives in backend/services/seo_render.py (AUTHOR_* constants + the /about
// body); keep the two in step when anything here changes.
export const AUTHOR = {
  name: 'Curtis White',
  role: 'Founder of Vegetablah',
  // Articles link their byline here; the About page anchors its founder section.
  path: '/about#author',
  github: 'https://github.com/compunct',
  youtube: 'https://www.youtube.com/@Vegetablah',
};

export const PROVENANCE_TEXT =
  'Written with AI assistance · Published by Curtis White, who builds and runs Vegetablah.';

export const DISCLAIMER_TEXT =
  'This article is general wellness information, not medical advice. ' +
  'Talk to a qualified clinician before changing your medication, diet, or exercise.';
